import React from 'react'
import { useTranslation } from 'react-i18next'

import { TEAM_MEMBER_CREATE } from '../../../../constants/forms'

import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import NewUserInviteForm from './NewUserInviteForm'

const NewUserInvite = ({ selfAccountId, isRightsHolderTeam }) => {
  const { t } = useTranslation()

  return (
    <FormDrawerWrapper
      formName={TEAM_MEMBER_CREATE}
      title={t('Add new member to the team')}
      openButtonText={t('Add a new team member')}
    >
      <NewUserInviteForm selfAccountId={selfAccountId} isRightsHolderTeam={isRightsHolderTeam} />
    </FormDrawerWrapper>
  )
}

export default NewUserInvite
